/**
 * 20 non-breaking spaces, which acts as a placeholder for loading text
 */
export const NON_BREAKING_SPACES = '\xa0'.repeat(20);
